import {useState} from "react";

export default function ViewRegimeInfos({ partnerInfos, apiPartnerInfos } ) {
    const [ showModal, setShowModal ] = useState(false);

    return (
        <>
            {/*{ showModal &&
                <div className="modal regime-infos">
                    <div>
                        <FormMatrimonialRegime setShowModal={setShowModal} apiPartnerInfos={apiPartnerInfos} partnerInfos={partnerInfos} legend="Informations du régime matrimonial"/>
                    </div>
                </div>
            }
            <form>
                <fieldset>
                    <legend>Régime matrimonial<i className="fa fa-pen-to-square" onClick={handleFormRegimeModal}/>
                    </legend>
                    <div className="form-input">
                    <label>Régime matrimonial :</label>
                        <span>{fullMatrimonialRegime[partnerInfos?.regime]}</span>
                    </div>
                </fieldset>
            </form>*/}
        </>
    )
}